import { Component, Inject, Input, OnDestroy } from '@angular/core';
import { TraaqrTag } from '../../../../core/models/traaqrTag';
import * as copy from 'copy-to-clipboard';
import * as _ from 'lodash';
import { mergeMap } from 'rxjs/operators';
import { TraaqrTagDao } from '../../../../core/services/dao/traaqrTagDao';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Router } from '@angular/router';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { IntegrationDao } from "../../../../core/services/dao/integrationDao";

@Component({
  selector: 'tracking-tag',
  templateUrl: './tracking-tag.component.html',
  styleUrls: ['tracking-tag.component.scss']
})
export class TrackingTagComponent implements OnDestroy {
  traaqrTag: TraaqrTag;
  embedCode: string;
  detected = false;
  saving = false;

  newIp = '';

  collapsed = true;
  accountsLoading = false;
  containersLoading = false;
  workspacesLoading = false;
  oAuthUrl = '';
  createdIntegration: any = {};
  accountOptions = [];
  containerOptions = [];
  workspaceOptions = [];
  errorMessage = '';
  selectedAccount;
  selectedContainer;
  selectedWorkspace;

  private subs = [];

  constructor(
    private traaqrTagDao: TraaqrTagDao,
    public snackBar: MatSnackBar,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TrackingTagComponent>,
    private apiHelper: ApiHelper,
    public integrationDao: IntegrationDao
  ) {
    this.traaqrTag = this.data.tag;
    this.embedCode = `<script async src="${this.apiHelper.embedUrl}/${this.traaqrTag.token}/page.js"></script>`;
    // let tagSub = this.traaqrTagDao.getStatus(this.traaqrTag.token).subscribe(res => {
    //   if (res) {
    //     this.detected = res;
    //   }
    // })
    // this.subs.push(tagSub);
    // let oAuthSub = this.integrationDao.getGoogleTagManagerOAuthUrl(this.data.brand).subscribe(res => {
    //   this.oAuthUrl = res['url'];
    // });
    // this.subs.push(oAuthSub);
  }

  copyEmbedCode() {
    let copied = copy(this.embedCode);
    if (copied) {
      this.snackBar.open('Embed Code Copied', 'Dismiss', {
        duration: 5000,
        verticalPosition: 'top'
      });
    }
  }

  refreshData() {
    // let tagSub = this.traaqrTagDao.getStatus(this.traaqrTag.token).subscribe(res => {
    //   if (res) {
    //     this.detected = res;
    //     this.snackBar.open('Embed Code has been successfully detected', 'OK', {
    //       duration: 5000,
    //       verticalPosition: 'top'
    //     });
    //   } else {
    //     this.snackBar.open('Embed Code has not been detected.', 'Dismiss', {
    //       duration: 10000,
    //       verticalPosition: 'top'
    //     });
    //   }
    // });
    // this.subs.push(tagSub);
  }

  addIpDisabled() {
    const pattern = new RegExp('\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}');
    return !(this.newIp && pattern.test(this.newIp));
  }

  addIp(e) {
    if (this.newIp) {
      this.traaqrTag.ips.push(this.newIp);
      this.newIp = '';
    }
  }

  removeIp(i) {
    this.traaqrTag.ips.splice(i, 1);
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  save(event) {
    this.saving = true;

    if (this.selectedAccount && this.selectedContainer && this.selectedWorkspace) {
      let updates = {
        type: "google_tag_manager",
        accountId: this.selectedAccount.accountId,
        containerId: this.selectedContainer.containerId,
        workspaceId: this.selectedWorkspace.workspaceId,
        friendlyName: this.selectedWorkspace.name
      };
      // this.integrationDao.update(this.createdIntegration.id, updates).subscribe(res => {
      //   this.createdIntegration = res;
      //   this.integrationDao.createGoogleTagManagerTag(this.createdIntegration.id, this.embedCode).subscribe(res => console.log(res));
      // });
    }

    if (!this.addIpDisabled()) {
      this.traaqrTag.ips.push(this.newIp);
      this.newIp = '';
    }
    let sub = this.traaqrTagDao.update(this.traaqrTag, this.traaqrTag.id).subscribe(
      res => {
        this.saving = false;
        this.dialogRef.close(true);
      },
      err => console.error(err)
    );
    this.subs.push(sub);
  }

  toggleCollapse(event) {
    this.collapsed = !this.collapsed;
  }

  onClick(event) {
    if (!this.oAuthUrl) {
      console.error('OAuth URL not loaded!');
      return false;
    }

    let opened = window.open(this.oAuthUrl, null, 'width=800,height=850,modal=yes,alwaysRaised=yes');

    // let listener = event => {
    //   if (event.data) {
    //     if (event.data.type && event.data.type === 'google_tag_manager' && event.data.id !== undefined) {
    //       this.accountsLoading = true;
    //       this.integrationDao
    //           .loadById(event.data.id)
    //           .pipe(mergeMap(res => {
    //             this.createdIntegration = res;
    //            // return this.integrationDao.getGoogleTagManagerAccounts(this.createdIntegration.id);
    //           }))
    //           .subscribe(accounts => {
    //             let items = _.map(accounts.data.account, i => {
    //               return i;
    //             });
    //
    //             this.accountOptions = _.map(items, (value, key) => {
    //               return {
    //                 name: key,
    //                 account: value
    //               };
    //             });
    //             this.errorMessage = '';
    //             if (this.accountOptions.length === 0) {
    //               this.errorMessage = 'No Google Tag Manager accounts found. Try a different Google Account.';
    //               this.removeIntegration(this.createdIntegration.id);
    //             }
    //
    //             this.accountsLoading = false;
    //           });
    //
    //       // remove listener
    //       window.removeEventListener('message', listener);
    //
    //       // close window
    //       opened.close();
    //     }
    //   }


    // window.addEventListener('message', listener);
  }

  selectedAccountChange() {
    // if (this.selectedAccount) {
    //   this.containersLoading = true;
    //   this.integrationDao.getGoogleTagManagerContainers(this.createdIntegration.id, this.selectedAccount.accountId)
    //       .subscribe(containers => {
    //         let items = _.map(containers.data.container, i => {
    //           return i;
    //         });
    //
    //         this.containerOptions = _.map(items, (value, key) => {
    //           return {
    //             name: key,
    //             container: value
    //           };
    //         });
    //
    //         this.errorMessage = '';
    //         if (this.containerOptions.length === 0) {
    //           this.errorMessage = 'No Google Tag Manager containers found. Try a different Google Account.';
    //           this.removeIntegration(this.createdIntegration.id);
    //         }
    //
    //         this.containersLoading = false;
    //       });
    // }
  }

  selectedContainerChange() {
    if (this.selectedContainer) {
      this.workspacesLoading = true;
    //   this.integrationDao.getGoogleTagManagerWorkspaces(this.createdIntegration.id, this.selectedAccount.accountId, this.selectedContainer.containerId)
    //       .subscribe(workspaces => {
    //         let items = _.map(workspaces.data.workspace, i => {
    //           return i;
    //         });
    //
    //         this.workspaceOptions = _.map(items, (value, key) => {
    //           return {
    //             name: key,
    //             workspace: value
    //           };
    //         });
    //
    //         this.errorMessage = '';
    //         if (this.workspaceOptions.length === 0) {
    //           this.errorMessage = 'No Google Tag Manager containers found. Try a different Google Account.';
    //           this.removeIntegration(this.createdIntegration.id);
    //         }
    //
    //         this.workspacesLoading = false;
    //       })
     }
  }

  selectedWorkspaceChange() {}


  removeIntegration(integrationId) {
    // this.integrationDao.disconnect(integrationId).subscribe(() => {
    //   console.log('Successfully removed integration');
    // });
  }
}
